import { decodeJwt } from "jose";
import { HeaderProfile } from "./HeaderProfile";
import Logo from "../assets/mona-logo-temp.png";
import { useEffect, useState } from "react";
import { BackButton } from "./BackButton";
import { Notification } from "./Notification";

export const Header = ({ location }) => {
  const [isUsernameVisible, setIsUsernameVisible] = useState(true);
  const isMobile = window.innerWidth <= 570;
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        if (window.innerWidth <= 570) {
          setIsUsernameVisible(false);
        }
      } else {
        setIsUsernameVisible(true);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const token = localStorage.getItem("access_token");
  if (!token) {
    return <></>;
  }
  const jwtPayload = decodeJwt(token);
  if (!jwtPayload) {
    return <></>;
  }
  const username = jwtPayload.username;
  if (!username) {
    return <></>;
  }

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        display: "flex",
        justifyContent: "space-between",
        boxShadow: "0 1px 6px rgba(0, 0, 0, 0.3)",
        position: "fixed",
        width: "100vw",
        zIndex: "3000",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "220px",
          marginLeft: isMobile ? "2rem" : "0",
        }}
      >
        {isMobile && location.pathname !== "/analytics" && <BackButton />}
        <img src={Logo} width={125} alt="Mona Logo" />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Notification />
        <HeaderProfile
          username={username}
          isUsernameVisible={isUsernameVisible}
        />
      </div>
      {!isUsernameVisible && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "60px",
          }}
        ></div>
      )}
    </div>
  );
};
